import WebviewBFPContentObject from './Webview';
import WebBFPContentObject from './Web';

function BFPContentObject(props) {
  const isWebview = props.isWebview;
  if (isWebview) {
    return <WebviewBFPContentObject {...props} />
  }
  return <WebBFPContentObject {...props} />
}

export default BFPContentObject;
